// client/src/utils/influencerContractCache.js

const CACHE_PREFIX = 'INF_CONTRACT_';
const CACHE_TTL = 5 * 60 * 1000; // 5분

// sessionStorage 헬퍼
const ss = typeof window !== 'undefined' ? window.sessionStorage : null;

function cacheSet(key, value) {
  if (!ss) return;
  try {
    ss.setItem(key, JSON.stringify({
      data: value,
      timestamp: Date.now(),
      uid: window.__ME__?.id
    }));
  } catch (e) {
    console.error('계약 캐시 저장 실패:', e);
  }
}

function cacheGet(key) {
  if (!ss) return null;
  try {
    const cached = ss.getItem(key);
    if (!cached) return null;
    
    const { data, timestamp, uid } = JSON.parse(cached);
    
    // TTL 체크
    if (Date.now() - timestamp > CACHE_TTL) {
      ss.removeItem(key);
      return null;
    }
    
    // 사용자 검증
    const currentUid = window.__ME__?.id;
    
    // currentUid가 없으면 null 반환 (로그인 전)
    if (!currentUid) {
      return null;
    }
    
    // currentUid가 있는데 캐시 uid와 다르면 삭제
    if (uid && uid !== currentUid) {
      console.warn('계약 캐시 사용자 불일치, 삭제:', key);
      ss.removeItem(key);
      return null;
    }
    
    return data;
  } catch (e) {
    console.error('계약 캐시 조회 실패:', e);
    return null;
  }
}

// 선정된 프로젝트 목록 캐시
export function cacheSelectedProjects(uid, projects) {
  if (!uid) return;
  cacheSet(`${CACHE_PREFIX}SELECTED_LIST:${uid}`, projects);
}

export function readSelectedProjects(uid) {
  if (!uid) return null;
  return cacheGet(`${CACHE_PREFIX}SELECTED_LIST:${uid}`);
}

// 캐시 초기화
export function clearInfluencerContractCache(uid) {
  if (!ss) return;
  try {
    const keys = Object.keys(ss);
    keys.forEach(key => {
      if (key.startsWith(CACHE_PREFIX)) {
        ss.removeItem(key);
      }
    });
    console.log('✅ 인플루언서 계약 캐시 초기화 완료');
  } catch (e) {
    console.error('계약 캐시 초기화 실패:', e);
  }
}

// 백그라운드 선정된 프로젝트 목록 로드
export async function warmSelectedProjects(uid) {
  if (!uid) return;
  
  try {
    const res = await fetch('/api/influencer/mybiz/projects/selected', {
      credentials: 'include'
    });
    const data = await res.json();
    
    if (res.ok && data.ok && data.projects) {
      cacheSelectedProjects(uid, data.projects);
      console.log(`✅ 선정된 프로젝트 ${data.projects.length}개 캐시 완료`);
      
      // 첫 번째 프로젝트 이미지 프리로드
      if (data.projects.length > 0 && data.projects[0].coverImage) {
        const img = new Image();
        img.src = data.projects[0].coverImage;
      }
      
      return data.projects;
    }
  } catch (e) {
    console.error('선정된 프로젝트 백그라운드 로드 실패:', e);
  }
  
  return null;
}

